"use client"

import Image from "next/image"

import * as styles from "./navbar.styled"

export const DalmaLogoLink = () => (
  <a href="https://www.dalma.co/de/home" className={styles.logoLink} title="dalma.co">
    <Image
      src="/img/dalma-logo-small.svg"
      width={24}
      height={24}
      alt="Dalma logo"
      className="lg:hidden"
    />
    <Image
      src="/img/dalma-logo.svg"
      width={77}
      height={24}
      alt="Dalma logo"
      className="hidden lg:block"
    />
  </a>
)
